import { ReactElement } from 'react';

import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { Translate } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { AdditionalEntitlement } from '~libs.shared.prescription';

import { prescriptionsTranslationKeys } from '../../../../../translations';
import { useGoToPrescriptionsHistoryDownload } from '../../../prescriptionsHistoryDownload/PrescriptionsHistoryDownload.hooks';

import { getModalContent } from './PatientPrescriptionsHistoryDownloadVerificationModal.utils';

type PatientPrescriptionsHistoryDownloadVerificationModalProps = {
   readonly visitId: number;
   readonly documentationScope: Visit['documentationScope'];
   readonly additionalEntitlements: AdditionalEntitlement[];
   readonly onClose: VoidFunction;
};

export const PatientPrescriptionsHistoryDownloadVerificationModal = (
   props: PatientPrescriptionsHistoryDownloadVerificationModalProps
): ReactElement => {
   const goToPrescriptionsHistoryDownload = useGoToPrescriptionsHistoryDownload();

   return (
      <Modal
         title={prescriptionsTranslationKeys.prescriptionHistoryDownloadVerification.verifyPatientPrescriptionsHistory}
         testId={'patientPrescriptionsHistoryVerification'}
         width={ModalWidth.NORMAL}
      >
         <Translate>{getModalContent(props.additionalEntitlements)}</Translate>
         <ModalCancelButton onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
         <ModalConfirmButton
            label={
               prescriptionsTranslationKeys.prescriptionHistoryDownloadVerification.goToPrescriptionsHistoryDownload
            }
            onClick={() => {
               goToPrescriptionsHistoryDownload(props.visitId, props.documentationScope, 'SPECIAL');
               props.onClose();
            }}
         />
      </Modal>
   );
};
